import { useMemo } from 'react'
import {
	Box,
	Stack,
	StackProps,
	Chip,
	Typography,
	List,
	ListItem,
	ListItemButton
} from "@mui/material"

import { ConventionsSessionResult } from 'interface/convention'

type ConventionSessionsLineStyle = {
	margin: number
	variant: 'h4' | 'h5' | 'body1' | 'body2'
}

type ConventionSessionsLineProps = {
	session: ConventionsSessionResult,
	onClickedSpeaker: (kojinCode: string) => void
} & StackProps

export const ConventionsSessionsLine = ({
	session,
	onClickedSpeaker,
	...others
} : ConventionSessionsLineProps) => {
	const style = useMemo<ConventionSessionsLineStyle>(() => {
		return (session.sessionLevel === 0) ? { margin: 3, variant: 'h5' } :
					 (session.sessionLevel === 1) ? { margin: 6, variant: 'body1' } :
					 (session.sessionLevel === 2) ? { margin: 9, variant: 'body2' } : { margin: 12, variant: 'body2' }
	}, [session.sessionLevel])

	return (
		<Stack direction='column' paddingLeft={style.margin} paddingRight={3} spacing={0.5} {...others}>
			<Stack direction='row' alignItems='baseline' width='100%'>
				{ session.sessionKey && (
					<Typography component='span' variant={style.variant} whiteSpace='nowrap'>{session.sessionKey}：</Typography>
				) }
				<Typography component='span' variant={style.variant}>{session.sessionTitle}</Typography>

				<Box flexGrow={1}/>

				{ session.sponcer && (
					<Chip
						variant="filled"
						color='default'
						label={session.sponcer}
						size='small'
					/>
				) }
			</Stack>
			
			{ session.speaker && session.speaker.length > 0 && (
				<List disablePadding>
					{ session.speaker.map((speaker, i) => {
						return (
							<ListItem  key={`speaker-${session.sessionId}-${i}`} disablePadding>
								<ListItemButton
									disabled={speaker.kojinCode ? false : true}
									onClick={() => {
										if (!speaker.kojinCode) return
										onClickedSpeaker(speaker.kojinCode)
									}}
								>
									<Stack direction='row' spacing={1} width='100%' alignItems='baseline'>
										<Chip
											variant="filled"
											color='default'
											label={speaker.role}
											size='small'
										/>
										{ speaker.kojinCode ? (
											<Typography component='span' variant='body1' color='text.primary' whiteSpace='nowrap'>{speaker.speakerName}</Typography>
										) : (
											<Typography component='span' variant='body1' color='text.secondary' whiteSpace='nowrap'>{speaker.speakerName}</Typography>
										) }
										<Typography component='span' variant='body2' color='text.secondary'>{speaker.affiliationName}</Typography>
										<Typography component='span' variant='body2' color='text.secondary'>{speaker.postName}</Typography>
										<Box flexGrow={1}/>
										{ speaker.score ?? 0 > 0 ? (
											<Typography component='span' variant='caption' color='text.primary' whiteSpace='nowrap'>{speaker.score} pt.</Typography>
										) : (
											<Typography component='span' variant='caption' color='text.secondary'>-</Typography>
										) }
									</Stack>
								</ListItemButton>
							</ListItem>
						)
					}) }
				</List>
			) }
		</Stack>
	)
}